import { JsonObject } from '../app/json/jsonValue.js';

export class DynamicConfig {
    iType: string = '';
    iParamFile: string = '';

    /**
     * Data-source allowlist for a CLIENT-DATA binding (dynamicclientdata.json only), as a case-insensitive
     * CSV SET, e.g. "Embedded", "Remote", or "Embedded,Remote". Two INDEPENDENT deliveries, not a mutually
     * exclusive enum: Embedded ships the raw once (island); Remote serves subsequent slices on demand; both
     * present = the paging hybrid (page 1 embedded, page N over URL). Empty for Data/View/Action bindings.
     * Membership is tested via hasDataSource (mirrors the SkipViewAppSitesFolder CSV idiom).
     */
    dataSource: string = '';

    constructor(iType: string = '', iParamFile: string = '') {
        this.iType = iType;
        this.iParamFile = iParamFile;
    }

    /**
     * Returns true when the given source token (e.g. "Embedded"/"Remote") is present in the
     * dataSource CSV allowlist, case-insensitively.
     */
    hasDataSource(source: string): boolean {
        if (!this.dataSource || !source) return false;
        for (const token of this.dataSource.split(',')) {
            if (token.trim().toLowerCase() === source.toLowerCase()) return true;
        }
        return false;
    }

    static fromJson(json: JsonObject, configType: string = 'View'): DynamicConfig {
        const config = new DynamicConfig();

        if (!json) return config;

        const getStr = (key: string): string | null => json.getString(key);

        const iTypeVal = getStr('IType');
        if (iTypeVal !== null) {
            config.iType = iTypeVal;
        } else {
            const legacyTypeKey = `I${configType}Type`;
            const legacyVal = getStr(legacyTypeKey);
            if (legacyVal !== null) {
                config.iType = legacyVal;
            }
        }

        const iParamVal = getStr('IParamFile');
        if (iParamVal !== null) {
            config.iParamFile = iParamVal;
        } else {
            const legacyParamKey = `I${configType}ParamFile`;
            const legacyVal = getStr(legacyParamKey);
            if (legacyVal !== null) {
                config.iParamFile = legacyVal;
            }
        }

        // Optional CLIENT-DATA source allowlist (Embedded/Remote/both). Absent for Data/View/Action.
        const dataSourceVal = getStr('DataSource');
        if (dataSourceVal !== null) {
            config.dataSource = dataSourceVal;
        }

        return config;
    }

    toJson(): Record<string, string> {
        return {
            IType: this.iType,
            IParamFile: this.iParamFile
        };
    }
}
